<template>
  <div id="projectFile">
    <div class="fileBox">
      <div class="btnRow">
        <!-- <el-button @click="handleMulu">生成目录</el-button> -->
      </div>
      <!-- 表格行 -->
      <div class="tableBox">
        <tree-table
          :is-fold="false"
          :data="tableData"
          :columns="columns"
          :show-row-hover="false"
          :expand-type="false"
          stripe
          :selection-type="true"
          @checkbox-click="handleSelectionChange"
        >
          <template slot="name1" slot-scope="scope">
            <span @click="showFile" style="cursor: pointer;">{{scope.row.name1 +'123'}}</span>
          </template>
          <template slot="upPeople" slot-scope="scope">
            <span>{{scope.row.upPeople}}</span>
          </template>
          <template slot="time" slot-scope="scope">
            <span>{{scope.row.time}}</span>
          </template>
          <template slot="edit" slot-scope="scope">
            <div>
              <el-button
                class="checkBtn"
                v-if="scope.row.type!='folder'"
                @click="checkItem(scope.row)"
              >查看</el-button>
              <el-button
                class="checkBtn1"
                v-if="scope.row.type!='folder'"
                @click="downloadFile(scope.row)"
              >下载</el-button>
            </div>
          </template>
        </tree-table>
      </div>
    </div>
    <!-- 附件详情弹窗 -->
    <el-dialog
      :visible.sync="imgDia"
      width="50%"
      :before-close="imghandleClose"
      class="addClientDia"
      node-key="id"
      @close="imghandleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">{{'河南邦泰合力管理咨询有限公司'}}</span>
      </div>
      <div class="diaContainer">
        <el-tree :data="data" :props="props" show-checkbox @check-change="handleCheckChange"></el-tree>
      </div>
      <div slot="footer" class="dialog-footer imgFooter">
        <el-button style="background-color:#ccc" type="primary" @click="imgDia=false">取 消</el-button>
        <el-button type="primary">生成目录</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgDia: false,
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      showForm: '',
      columns: [
        {
          label: '文件名',
          type: 'template',
          template: 'name',
          prop: 'name',
          width: '500',
        },
        {
          label: '上传人',
          type: 'template',
          prop: 'upPeople',
          template: 'upPeople',
        },
        {
          label: '上传时间',
          type: 'template',
          prop: 'time',
          template: 'time',
        },
        {
          label: '操作',
          type: 'template',
          width: '180',
          template: 'edit',
          headerAlign: 'center',
          align: 'center',
        },
      ],
      tableData: [],
      props: {
        label: 'label',
        children: 'children',
      },
      member_id: '',
      data: [
        {
          id: 1,
          label: '邦泰1',
          children: [
            {
              id: 4,
              label: '邦泰2',
            },
          ],
        },
      ],
      token: '',
      checkOutImgIndex: '',
      details_project_id: '',
      details_project_status: '',
    }
  },
  methods: {
    // 下载文件
    downloadFile(item) {
      window.open(item.url)
      // this.downloadIamge(item.url, item.name)
    },
    // 查看文件
    checkItem(item) {
      if (
        item.type == 'pdf' ||
        item.type == 'PDF' ||
        item.type == 'jpeg' ||
        item.type == 'JPEG' ||
        item.type == 'MP4' ||
        item.type == 'mp4' ||
        item.type == 'png' ||
        item.type == 'PNG' ||
        item.type == 'mp4' ||
        item.type == 'jpg' ||
        item.type == 'JPG'
      ) {
        window.open(item.url)
      } else if (
        item.type == 'xls' ||
        item.type == 'XLS' ||
        item.type == 'xlsx' ||
        item.type == 'XLSX' ||
        item.type == 'pot' ||
        item.type == 'POT' ||
        item.type == 'ppt' ||
        item.type == 'PPT' ||
        item.type == 'POTX' ||
        item.type == 'potx' ||
        item.type == 'doc' ||
        item.type == 'DOC' ||
        item.type == 'DOCX' ||
        item.type == 'docx'
      ) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + item.url
        )
      } else {
        return this.$message.error('该类型文件无法预览')
      }
    },
    handleCheckChange(val1, val2, val3) {
      console.log('val1', val1)
      console.log('val2', val2)
      console.log('val3', val3)
    },
    handleMulu() {
      this.imgDia = true
    },
    // table选中状态
    handleSelectionChange(row, rowIndex, $event) {
      // console.log('row', row)
      console.log('rowIndex', rowIndex)
      // console.log('select123123ionri', $event)
    },
    handleClosed() {},
    imghandleClose(done) {
      this.imgDia = false
    },
    imghandleClosed() {},
    // 获取列表数据
    async getFileList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('project_id', this.details_project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/file_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData = res.datas.list
      console.log('项目---文件列表', this.tableData)
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getFileList()
    }
  },
}
</script>
<style lang="less" scoped>
#projectFile {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 30px;
  .fileBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
    .btnRow {
      width: 100%;
      padding-top: 30px;
      padding-bottom: 20px;
      display: flex;
      justify-content: flex-end;
      /deep/.el-button {
        font-size: 20px;
        font-weight: normal;
        border: none;
        width: 170px;
        height: 48px;
        background: #40a0f2;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    .tableBox {
      height: calc(100% - 98px - 30px);
      /deep/.zk-table {
        height: 100%;
        .zk-table__body-wrapper {
          height: calc(100% - 65px) !important;
          overflow-y: auto;
        }
      }
    }
  }
}

// 修改弹窗样式
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 3vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }

    .dialog-footer {
      width: 100%;
      display: flex;
      padding-left: 30%;
      margin-top: 30px;
      .el-button {
        // width: 180px;
        width: 23%;
        height: 50px;
        padding: 0;
        font-size: 20px;
        font-weight: normal;
        color: #fff;
        border: none;
        border-radius: 25px;
        background-color: #40a0f2;
        margin-bottom: 10px;
      }
      .el-button:first-child {
        margin-right: 5%;
      }
    }
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
// 修改表格样式
#projectFile {
  /deep/.zk-table {
    font-size: 16px;
  }
  /deep/.zk-table__body-row {
    height: 60px;
  }
  /deep/.zk-table__body-row:not(:first-of-type) {
    border-top: none;
  }
  /deep/.zk-table__header-row {
    background-color: #40a0f2;
    line-height: 50px;
    font-size: 20px;
    color: #fff;
    .zk-table__header-cell {
      font-weight: normal;
    }
  }
  /deep/.zk-table--firstProp-header-inner {
    padding-left: 15px;
  }
}
// 修改表格收缩图标
/deep/.zk-icon {
  display: inline-block;
  vertical-align: middle;
  width: 19px;
  height: 16px;
  background: url(../../../assets/image/icon_wenj@2x.png) no-repeat;
  background-size: 100% 100%;
}
/deep/.zk-icon::before {
  display: none;
}
.diaContainer {
  padding-left: 100px;
  /deep/.el-tree-node__content {
    height: 40px;
    .el-tree-node__label {
      font-size: 16px;
    }
  }
}
/deep/.checkBtn {
  color: #0099ff;
  border-color: #0099ff;
  font-weight: normal;
  padding: 0 15px;
  height: 32px;
}
/deep/.checkBtn1 {
  color: rgb(48, 173, 95);
  border-color: rgb(48, 173, 95);
  font-weight: normal;
  padding: 0 15px;
  height: 32px;
}
</style>
